export const DEFAULT_RANGE_VALUE = {from: null, to: null};
